export const SHOP_FORM_ERROR_TRANSLATIONS: Record<string, any> = {
  required: 'This is a required field.',
  emailInvalid: 'Please enter a valid email address.',
  minlength: (requiredLength: number) => `Please enter a min of ${requiredLength} characters.`,
  maxlength: (requiredLength: number) =>
    `Character length must be shorter than or equal to ${requiredLength}.`,
  trimmed: `Please remove any spaces.`,
  noSpaces: `Please remove any spaces.`,
};
